export const InsuranceConfigVI = {
    "insuranceConfig": {
        "header": "Cài đặt bảo hiểm",
        "insuranceConfigConditionsForIncreaseInsurance": "Điều kiện tăng bảo hiểm",
        "closingDateForMonthlyIncrease": "Ngày chốt tăng hàng tháng",
        "conditionsForIncreaseInsurance1": "Tăng lao động đóng BHXH, BHYT, BHTN trong trường hợp này được hiểu là tăng số lượng người lao động tham gia đóng BHXH, BHYT, BHTN.",
        "conditionsForIncreaseInsurance2": "Những phát sinh tăng trước ngày này sẽ báo tăng tháng này, còn sau ngày này sẽ báo tăng tháng sau.",
        "signEmployeeContract": "Ký hợp đồng lao động",
        "backToWorkMaternity": "Nghỉ thai sản quay lại làm việc",
        "backToWorkUnpaid": "Nghỉ không lương theo quy định (đã báo giảm) quay trở lại làm việc",
        "incrementAmount": "Tăng mức đóng",
        "insuranceConfigConditionsForDecreaseInsurance": "Điều kiện giảm bảo hiểm",
        "closingDateForMonthlyDecrease": "Ngày chốt giảm hàng tháng",
        "conditionsForDecreaseInsurance1": "Giảm lao động đóng BHXH, BHYT, BHTN trong trường hợp này được hiểu là giảm số lượng người lao động tham gia đóng BHXH, BHYT, BHTN.\n",
        "conditionsForDecreaseInsurance2": "Những phát sinh giảm trước ngày này sẽ báo giảm tháng này, còn sau ngày này sẽ báo giảm tháng sau.",
        "decrementReSign": "Hợp đồng lao động được đóng bảo hiểm nghỉ việc",
        "offWorkMaternity": "Nghỉ thai theo chế độ",
        "decrementAmount": "Giảm mức đóng",
        "decrementAmountContent": "Đối với trường hợp người lao động không làm việc và không hưởng tiền lương quá số ngày nghỉ tối đa hàng tháng thì không đóng BHXH tháng đó. Thời gian này không được tính để hưởng BHXH.",
        "offWorkUnpaid": "Nghỉ không lương",
        "unpaidMaxDay": "Số ngày tối đa nghỉ không lương hàng tháng",
        "insuranceRate": "Tỷ lệ bảo hiểm",
        "insuranceRateContent": "Cài đặt này sẽ ứng với toàn bộ hồ sơ nhân sự",
        "insuranceRateFromMonth": "Từ tháng",
        "insuranceAmount": "Mức đóng",
        "socialInsuranceRate": "Bảo hiểm xã hội",
        "accidentInsuranceRate": "Bảo hiểm TNLĐ - BNN",
        "healthInsuranceRate": "Bảo hiểm y tế",
        "unemploymentInsuranceRate": "Bảo hiểm thất nghiệp",
        "totalInsuranceRate": "Tổng cộng",
        "placeholderAmount": "Số tiền",
        "placeholderCompany": "CTY",
        "placeholderEmployee": "NLĐ",
        "autoCalculate": "Tự động tính toán lại bảo hiểm từ tháng hiện tại",
        "autoCalculateContent": "Trong đó, các ô màu xám là số % người lao động chi trả",
        "employeeContractConfig": "Hợp đồng lao động",
        "employmentType": " Cài đặt hình thức làm việc"
    }
}